import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/themepark',
      name: 'themepark',
      component: () => import('./views/ThemePark.vue')
    },
    {
      path: '/museum',
      name: 'museum',
      component: () => import('./views/Museum.vue')
    },
    {
      path: '/freeform',
      name: 'freeform',
      component: () => import('./views/FreeForm.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/buzz',
      name: 'buzz',
      component: () => import('./views/AboutBuzz.vue')
    },
    {
      path: '/creators',
      name: 'creators',
      component: () => import('./views/Creators.vue')
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: () => import('./views/Disclaimer.vue')
    },
    {
      path: '/reading',
      name: 'reading',
      component: () => import('./views/Reading.vue')
    },
    {
      path: '*',
      name: 'catchAll',
      component: Home
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// router.beforeEach((to, from, next) => {
// })

export default router
